import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas } from "react-bootstrap";
import { FiX, FiShoppingBag } from "react-icons/fi";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      <Offcanvas.Header className="minimal-cart-header">
        <Offcanvas.Title className="minimal-cart-title">
          <FiShoppingBag size={20} className="me-2" /> YOUR BAG
        </Offcanvas.Title>
        <button 
          className="cart-close-btn" 
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <FiX size={24} />
        </button>
      </Offcanvas.Header>

      <Offcanvas.Body className="minimal-cart-body">
        {cartItems && cartItems.length ? (
          <>
            <div className="cart-items-scroller">
              {cartItems.map((item, index) => (
                <CartItems key={item._id || index} item={item} />
              ))}
            </div>

            <div className="minimal-cart-footer">
              <div className="summary-rows">
                <div className="summary-line">
                  <span>Subtotal</span>
                  <span>₹{cartSummary.subtotal}</span>
                </div>
                
                {cartSummary.shipping > 0 && (
                  <div className="summary-line">
                    <span>Shipping</span>
                    <span>+₹{cartSummary.shipping}</span>
                  </div>
                )}

                {cartSummary.discount > 0 && (
                  <div className="summary-line discount-text">
                    <span>Discount</span>
                    <span>-₹{cartSummary.discount}</span>
                  </div>
                )}

                <div className="summary-line total-line">
                  <span>TOTAL</span>
                  <span>₹{cartSummary.total}</span>
                </div>
              </div>

              <div className="cart-actions mt-4">
                <Link
                  to="/cart"
                  className="btn-minimal-cart primary-cart-btn"
                  // data-bs-dismiss="offcanvas"
                >
                  PROCEED TO CHECKOUT
                </Link>
                <Link
                  to="/shop"
                  className="btn-minimal-cart secondary-cart-btn"
                  data-bs-dismiss="offcanvas"
                >
                  CONTINUE SHOPPING
                </Link>
              </div>
            </div>
          </>
        ) : (
          <div className="cart-empty-state">
            <div className="empty-icon-circle">
               <FiShoppingBag size={40} />
            </div>
            <h5>Your bag is empty</h5>
            <p>Looks like you haven't added anything to your bag yet.</p>
            <Link
              to="/shop"
              className="shop-now-btn-minimal"
              data-bs-dismiss="offcanvas"
            >
              START SHOPPING
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;